import React, { ChangeEvent, FormEvent, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { PasswordRecoveryLabels } from "../../../assets/labels/labels";
import { IconClient } from "../../../assets/svgs-index";
import PoweredBy from "../../../components/PoweredBy/PoweredBy";
import ModalInformation from "../../../components/Modals/ModalInformation";
import { AuthenticationService } from "../../../core/services/authentication.service";
import PasswordRecoverySent from "./PasswordRecoverySent";
import { Helper } from "../../../core/services/helper/helper.service";
import { CompanyService } from "../../../core/services/company.service";
import Cookies from "universal-cookie";

const PasswordRecovery: React.FC<{ emailSent?: boolean }> = (props) => {
  const cookies = useMemo(() => new Cookies(), []);
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isEmbedded = Helper.isEmbedded();
  const domain = location?.state?.domain || cookies.get("kssreturncompany")?.replace(".qa", "");

  const [email, setEmail] = useState<string>(searchParams.get("email") || location?.state?.email);

  const [modalInfoIsOpen, setModalInfoIsOpen] = useState<boolean>(false);
  const [modalInfoMessage, setModalInfoMessage] = useState<string>("");
  const [modalInfoSubMessage, setModalInfoSubMessage] = useState<string>("");
  const [modalInfoTitle, setModalInfoTitle] = useState<string>("");
  const [modalInfoConfirmText, setModalInfoConfirmText] = useState<string>("");

  const handleClickLogin = () => {
    let url = "/login";
    if (isEmbedded) {
      url += `?embedded=${encodeURIComponent(isEmbedded)}`;
    }
    navigate(url, { state: { email } });
  };

  const handleChangeEmail = (e: ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    AuthenticationService.passwordRecovery({ email }, navigate).then((res) => {
      if (res) {
        res?.title && setModalInfoTitle(res.title);
        res?.message && setModalInfoMessage(res.message);
        res.subMessage && setModalInfoSubMessage(res.subMessage);
        res.confirmText && setModalInfoConfirmText(res.confirmText);
        setModalInfoIsOpen(true);
      }
    });
  };

  const renderModalInformation = (handler?: any) => {
    if (!modalInfoIsOpen) {
      return <React.Fragment />;
    }
    return (
      <ModalInformation
        modalIsOpen={modalInfoIsOpen}
        title={modalInfoTitle}
        message={modalInfoMessage}
        subMessage={modalInfoSubMessage}
        confirmText={modalInfoConfirmText}
        onClose={() => closeModal()}
        onConfirm={handler || closeModal}
      />
    );
  };

  const closeModal = () => {
    setModalInfoIsOpen(false);
    setModalInfoTitle('');
    setModalInfoMessage('');
    setModalInfoSubMessage('');
    setModalInfoConfirmText('');
  }

  const renderPassordRecovery = () => {
    if (props.emailSent) {
      return <PasswordRecoverySent />;
    }

    return (
      <div className="grey-box-container mt-6 py-4 px-6 w-100">
        <div className="box-form-container">
          <h3 className="text-center w-100">{PasswordRecoveryLabels.title}</h3>
          <div className="text-center message-container mt-4">{PasswordRecoveryLabels.message}</div>
          <form onSubmit={handleSubmit}>
            <div className="input-container mt-3">
              <p className="input-label">Utilizador</p>
              <input
                className="input-medium-default"
                type="email"
                title="Utilizador"
                pattern="[^\s@]+@[^\s@]+\.[^\s@]+"
                value={email}
                placeholder="exemplo@mail.com"
                onChange={handleChangeEmail}
                required={true}
              />
            </div>
            <button
              className="cta-button-primary d-medium w-100 mt-4"
              type="submit"
              value={PasswordRecoveryLabels.submitButton}
            >
              {PasswordRecoveryLabels.submitButton}
            </button>
          </form>
        </div>
        <div className="link-container mt-4 text-center" onClick={handleClickLogin}>
          {PasswordRecoveryLabels.linkMessage}
        </div>
      </div>
    );
  };

  const renderEmbeddedHeader = () => {
    return (
      <>
        <div className="header w-100 d-flex flex-row justify-content-between ps-md-9 opacity-50">
          <div className="logo-container d-flex flex-column">
            <div className="company-logo mt-2 mx-3 mx-md-4">
              <img className="kmclient-logo"
              src={domain ? CompanyService.urlCompanyImage(`domain/${domain}`) : IconClient}
              alt="logo"
              onError={(e) => ((e.target as HTMLImageElement).src = IconClient)} />
            </div>
          </div>
          <div className="app-logo-container me-3 me-md-4 align-items-center">
            {" "}
            <PoweredBy isTop={true}/>
          </div>
        </div>
      </>
    )
  }

  const containerStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.7)', // semi-transparent background
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000, // Ensure it's on top of other elements
    maxWidth: 'none',

  };

  const iframeContainerStyle = {
    width: '96%',
    height: '200%',
    backgroundColor: '#fff',
    borderRadius: '8px',
    //overflow: 'hidden',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    position : 'relative',
  };

  const embeddedContainerStyle = isEmbedded ? containerStyle : {};
  const embeddedIframeContainerStyle = isEmbedded ? iframeContainerStyle : {};

  return (
    <div className={`main-page-container pb-4 h-100 pt-0 align-center justify-content-start ${isEmbedded ? 'mt-0 ' : 'mt-4 container'}`} style={embeddedContainerStyle}>
      {!isEmbedded &&
        <>
          <div className="company-logo-container mt-2 mt-md-4" onClick={() => navigate("/")}>
            <img className="kmclient-logo"
              src={domain ? CompanyService.urlCompanyImage(`domain/${domain}`) : IconClient}
              alt="logo"
              onError={(e) => ((e.target as HTMLImageElement).src = IconClient)} />
          </div>
        </>
      }
      {isEmbedded && renderEmbeddedHeader()}
      {isEmbedded ? (
        <div style={embeddedIframeContainerStyle}>
          {renderPassordRecovery()}
          {!isEmbedded &&
            <>
              <div className="powered-by-container mt-4">
                {" "}
                <PoweredBy />
              </div>
            </>
          }
          {renderModalInformation()}
        </div>
      )
        :
        (<>
          {renderPassordRecovery()}
          {!isEmbedded &&
            <>
              <div className="powered-by-container mt-4">
                {" "}
                <PoweredBy />
              </div>
            </>
          }
          {renderModalInformation()}
        </>)
      }
    </div>
  );
};

export default PasswordRecovery;
